
import { defineComponent } from 'vue';
import { MatomoUrl, translate } from 'CoreHome';

export default defineComponent({
  props: {
    currentTab: {
      type: String,
      required: true,
    },
  },

  methods: {
    getNavigationUrl(action: string) {
      return `?${MatomoUrl.stringify({
        ...MatomoUrl.urlParsed.value,
        module: 'SearchEngineKeywordsPerformance',
        action,
      })}`;
    },
    translate,
  },
  computed: {
    setupUrl() {
      return this.getNavigationUrl('index');
    },
    googleUrl() {
      return this.getNavigationUrl('configureGoogle');
    },
    bingUrl() {
      return this.getNavigationUrl('configureBing');
    },
    yandexUrl() {
      return this.getNavigationUrl('configureYandex');
    },
  },
});
